/*eslint-disable*/
import React from 'react'
import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'

// helpers
import { getFullName, getLastLogin } from '../../../../helpers/users'
import Breadcrumbs from '../../../../components/Breadcrumbs'
import styles from './pageHeader.module.scss'

const PageHeader = ({ user }) => {
  const { t } = useTranslation()

  const userFullName = getFullName(user)

  const breadcrumbPath = [
    { label: 'users-edit-tab', path: '/search-user' },
    { label: userFullName },
  ]

  return (
    <Box
      className={styles.pageHeaderContainer}
    >
      <Breadcrumbs crumbs={breadcrumbPath} className={styles.pageHeaderBreadcrumbs} />
      <h1
        className={styles.pageHeaderTitle}
      >
        {getFullName(user)}
      </h1>
      <p
        className={styles.pageHeaderCopy}
      >
        {t('view-user-last-login')}
        {getLastLogin(user)}
      </p>
    </Box>
  )
}

export default PageHeader
